import { ActionReference, TimerAlias } from "@shared/types";
import { deepEqual } from "../helpers";

/** Variable that holds the current timeout */
let timeout: NodeJS.Timeout;

/**
 * A simple timer that calls a callback after a certain amount of time, only one timer can be active at a time
 * @param seconds the amount of time to wait before calling the callback in seconds
 * @param callback the function to call after the time has passed
 */
export function setTimer(seconds: number, callback: () => void): void {
    timeout = setTimeout(callback, seconds * 1000);
}

/**
 * Clears the current timer
 */
export function clearTimer(): void {
    clearTimeout(timeout);
}

/**
 * Sets a timer based on the alias
 * @param customActionAlias the alias of the timer to set
 */
export function setEventTimer(timerAlias: TimerAlias, callback: (button: ActionReference) => void): void {
    if (deepEqual(timerAlias, TimerAliases.selfDestruct)) {
        setTimer(5, () => {
            callback({
                alias: "self-destruct",
                label: "Self Destruct",
                needsObject: false,
            });
        });
    } else if (deepEqual(timerAlias, TimerAliases.escape)) {
        clearTimer();
    }
}

/**
 * A class that holds all the aliases for the timers
 */
export class TimerAliases {
    public static readonly selfDestruct: TimerAlias = {
        actionAlias: "use-action",
        objectAlias: "terminal",
    };
    public static readonly escape: TimerAlias = {
        actionAlias: "use-action",
        objectAlias: "outside-door",
    };
}
